import Axios from '@/assets/js/AxiosPlugin'
// 会员列表
export const searchMemberList = params => {
  return Axios.post('api/Admin/Statistics/memberOnRecords', params)
}



// WEBPACK FOOTER //
// ./src/views/webpc/MemberStatistics/rcStatisticsApp/apis/index.js